import useSWRImmutable from 'swr/immutable'

import {
  fetchHeaderServicesPages,
  getHeaderServicesPagesSWRKey,
} from '@/src/domains/header/services/fetchHeaderServicesPages'

export const useHeaderServicePages = () => {
  return useSWRImmutable(getHeaderServicesPagesSWRKey(), fetchHeaderServicesPages, {
    suspense: true,
  })
}
